module.exports = __webpack_public_path__ + "img/ticket.460f2c21.png";